import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import dateToString from '../../helpers/dateToString';
import { useTheme } from '@mui/material';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const PREFIX = 'MonthSelectItem';

const classes = {
    formControl: `${PREFIX}-formControl`,
    date: `${PREFIX}-date`,
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        minWidth: '100%',
    },

    [`& .${classes.date}`]: {
        fontSize: '10px' /*not used */
    }
}));

function MonthSelect(props) {

    const {
        date,
        handleDateChange,
        required,
        minDate,
        maxDate
    } = props;

    var requiredAsterisk = null;
    if (required) {
        requiredAsterisk = <Box color="error.main"> *</Box>;
    }
    const theme = useTheme();

    var minDateString = dateToString(minDate);
    var maxDateString = dateToString(maxDate);

    return (
        <Root >
            <Typography component={'div'} sx={{fontSize: theme.typography.pxToRem(14)}}>
                <div style={{ display: "flex" }}>
                    Seleccione un mes {requiredAsterisk}
                </div>
            </Typography>

            <FormControl className={classes.formControl}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        disableToolbar
                        autoOk
                        locale='es-ES'
                        format="MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={date}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        minDate={minDate}
                        maxDate={maxDate}
                        minDateMessage={"La fecha debe ser después de la fecha mínima con datos: "+minDateString}
                        maxDateMessage={"La fecha debe ser antes de la fecha máxima con datos: "+maxDateString}
                        invalidDateMessage={"Formato de fecha inválido."}
                        placeholder="mm/aaaa"
                        openTo="year"
                        views={["year","month"]}
                        slotProps={{ 
                            textField: { 
                                variant: 'standard'
                            } 
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
        </Root>
    );
}

function MonthSelectItem(props) {
    return (
        <div>
            <ListItem>
                <ListItemText primary={
                    <MonthSelect
                        {...props}
                    />
                } />

            </ListItem>
            <Divider />
        </div>
    )

}

export default MonthSelectItem;